import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FilterChangedEvent, GridOptions, SelectionChangedEvent } from 'ag-grid-community';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { AddresolutionordersService } from 'src/app/services/addresolutionorders.service';

@Component({
    selector: 'app-addresolutionordersgrid',
    templateUrl: './addresolutionordersgrid.component.html',
    styleUrls: ['./addresolutionordersgrid.component.scss'],
    standalone: false // NOSONAR
})
export class AddresolutionordersgridComponent implements OnInit, OnChanges {
  gridApi: any;
  highlightUnVerified: any = false;
  highlightVerified: any = false;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[]=[];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  selectedTab: any;
  successMessage: any;
  selectedRows: number[] =[];
  @Input() data: any[];
  @Output() select: EventEmitter<any[]>=new EventEmitter<any[]>(); // NOSONAR
  rowSelection: 'single' | 'multiple' = 'multiple';
  errorMessage: any;
  caCodeArr: any;
  constructor(  private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private readonly addResolutionOrdersService: AddresolutionordersService,
    public constants: Constants,) {
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true
    }
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',           // NOSONAR
    };
  }

  ngOnInit(): void {
    this.caCodeCall();
  }
  getColumnDef() {
    this.columnDefs = [
      {
        headerName: "", field: "",
        floatingFilter: false,
        floatingFilterComponentParams: { suppressFilterButton: true },
        headerCheckboxSelection: true,
        checkboxSelection: true,
      },
      {
        headerName: "UNLOAD", field: "arrival", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, 
        //maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "ROUTE", field: "route1", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, 
        //maxWidth: 100,
      },
      {
        headerName: "REGION", field: "region", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, 
        //maxWidth: 100,
      },
      {
        headerName: "SUPPLIER", field: "supplierId", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, 
        //maxWidth: 100,
      },
      {
        headerName: "CA CODE", field:"caCode", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, 
        //maxWidth: 100, 
        valueGetter: this.MapCaCode.bind(this),
      },
      {
        headerName: "MTM CODE", field: "mtmCode", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 120, maxWidth: 130,
      },
      {
        headerName: "PLANT", field: "plantId", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, maxWidth: 100,
      },
      {
        headerName: "DOCK", field: "logicalDockId", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90, 
        //maxWidth: 100,
      },
      {
        headerName: "ORDER NUMBER", field: "orderNumber", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true,
        minWidth: 120,
        //maxWidth: 130,
      },
      {
        headerName: "RELOAD", field: "reloadStart", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true,
        unSortIcon: true, minWidth: 115, 
        //maxWidth: 135,
        comparator: this.dateComparator,
      },
      {
        headerName: "NEXT ROUTE", field: "nextRoute", floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 115,
        //maxWidth: 125,
      },
    ]
  }
  caCodeCall() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.addResolutionOrdersService.getAllCanadaCode().subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.caCodeArr = res;
         
        this.getColumnDef();
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        
      },
    });
  }
  MapCaCode (params: any) {
    return this.caCodeArr[params.data.supplierId]
 }
  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }
  dateFormatter(res) {

    if (res == null) {return '';} // NOSONAR

    else {return moment(res).format('MM/DD/YYYY HH:mm');}

  }
  dayFormatterNotUTC(res) {

    if (res == null) {return '';} // NOSONAR

    else {return moment(res).format('MM/DD/YYYY');}

  }
  onModelUpdated(): void {
    
    this.sizeToFit();
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.displayRowData = this.data;
    //Integrated Part
    this.displayRowData = this.displayRowData.map((item: any) => {
      return {
        ...item,
        arrival: this.dayFormatterNotUTC(item.arrival),
        reloadStart: this.dateFormatter(item.reloadStart),
      };
    });
    this.gridApi.applyTransaction({ add: this.displayRowData }); 
    this.rowCount = this.displayRowData.length;
    this.gridApi?.redrawRows();
  }
  ngOnChanges(_changes) {
    this.displayRowData = this.data;
    this.displayRowData = this.displayRowData.map((item: any) => {
      return {
        ...item,
        arrival: this.dayFormatterNotUTC(item.arrival),
        reloadStart: this.dateFormatter(item.reloadStart),

      };
    }); 
    
       
    this.gridApi.applyTransaction({ add: this.displayRowData }); 
    this.rowCount = this.displayRowData.length;
    this.gridApi?.redrawRows();
  }

  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if (this.rowCount == 0 && Number(check) == 0) { // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML = '0';
    }
  }
  onSelectionChanged(event: SelectionChangedEvent) {
    const selected = [];
    event.api.getSelectedNodes().forEach(value=>{
      selected.push(value.data);  
    })
    this.select.emit(selected);
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else {
      this.currentPageBoolean = false;
      
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;
      
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
    else{
      (document.querySelector(selector) as any).innerHTML = 0;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }
}
function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}


